import { useRef, useState } from "react";
import {
    Form,
    Input
} from './tableSearchFormElements'

const TableSearchForm = ({onSubmit}) => {
    const [q, setQ] = useState('');
    const typingTimeOutRef = useRef(null);
    const handleSearchTermChange = e => {
        setQ(e.target.value);

        if (!onSubmit) return;

        if (typingTimeOutRef.current) {
            clearTimeout(typingTimeOutRef.current);
        }
        typingTimeOutRef.current = setTimeout(() => {
            const formValue = {
                q: e.target.value,
            };

            onSubmit(formValue);

        }, 300);

    };


    return (
        <Form onSubmit={e => e.preventDefault()}>
          <Input onChange={handleSearchTermChange} value={q} label="Bạn cần tìm gì ?" type="text" />  
        </Form>
    )
}

export default TableSearchForm
